/**
 * Route guard: renders its children only for a signed-in user.
 * Unauthenticated visitors are redirected to `/login`, preserving the
 * route they were trying to reach in `location.state.from`.
 */
import { Navigate, useLocation } from "react-router";
import type { ReactNode } from "react";
import { useAuth } from "./AuthContext";
import { AuthLoading } from "./AuthLoading";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") return <AuthLoading />;

  if (status !== "authed") {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <>{children}</>;
}
